// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1__f4a940d2dc041b953b9b","cls2":"ImpactHubProfileCard-cls2___25e48e1ff6240bf4418 ImpactHubProfileCard-cls1__f4a940d2dc041b953b9b"};